import { useNavigate } from 'react-router-dom'
import BackHeader from '../../../../components/BackHeader/BackHeader'
import './GameHeader.css'

const GameHeader = ({ points, onLeaderboardClick }) => {
  const navigate = useNavigate()
  const hasPoints = typeof points === 'number'

  return (
    <BackHeader
      theme="cl"
      eyebrow="Svirr"
      title="CL spil"
      subtitle={hasPoints ? `${points} point` : undefined}
      onBack={() => navigate('/spil')}
      backLabel="Tilbage til spil"
      actions={onLeaderboardClick ? (
        <button
          type="button"
          className="leaderboard-button"
          onClick={onLeaderboardClick}
          title="Se leaderboard"
        >
          Leaderboard
        </button>
      ) : null}
    />
  )
}

export default GameHeader
